
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { 
  Briefcase, 
  HandCoins, 
  Shield, 
  Stethoscope, 
  Home, 
  PencilRuler 
} from 'lucide-react';

interface CategoryTabsProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({
  selectedCategory,
  onCategoryChange
}) => {
  return (
    <Tabs 
      defaultValue="general" 
      value={selectedCategory} 
      onValueChange={onCategoryChange}
      className="w-full"
    >
      <TabsList className="w-full grid grid-cols-3 md:grid-cols-6">
        <TabsTrigger value="general" className="text-xs px-1">
          <Briefcase className="h-3 w-3 mr-1" /> General
        </TabsTrigger>
        <TabsTrigger value="banking" className="text-xs px-1">
          <HandCoins className="h-3 w-3 mr-1" /> Banking
        </TabsTrigger>
        <TabsTrigger value="insurance" className="text-xs px-1">
          <Shield className="h-3 w-3 mr-1" /> Insurance
        </TabsTrigger>
        <TabsTrigger value="healthcare" className="text-xs px-1">
          <Stethoscope className="h-3 w-3 mr-1" /> Healthcare
        </TabsTrigger>
        <TabsTrigger value="real-estate" className="text-xs px-1">
          <Home className="h-3 w-3 mr-1" /> Real Estate
        </TabsTrigger>
        <TabsTrigger value="custom" className="text-xs px-1">
          <PencilRuler className="h-3 w-3 mr-1" /> Custom
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default CategoryTabs;
